const BASE_URL =
	'https://dpjye2wk9gi5z.cloudfront.net/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/default/';

const getLastPartOfUrl = (url: string) => url.split('/').pop() || '';

export const getImage = (url: string) => `${BASE_URL}${getLastPartOfUrl(url)}`;
